import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { ConfirmDeleteDialog } from "@/lib/Components/Dialog/ConfirmDeleteDialog";

export function useConfirmDeleteDialog() {
  return useDialog(ConfirmDeleteDialog);
}
